export const FormSectionTitleSize = {
  Sm: 'sm',
  Md: 'md',
} as const;

export type FormSectionTitleSize =
  (typeof FormSectionTitleSize)[keyof typeof FormSectionTitleSize];

export type FormSectionProps = {
  title?: string;
  description?: string;
  titleSize?: FormSectionTitleSize;
  hideDivider?: boolean;
  testId?: string;
};

export type FormSectionRowProps = {
  full?: boolean;
  testId?: string;
};
